export function getRoomLabel(id, data) {
    return data.rooms.find(room => room.id === id)?.title || '';
}
